import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
// import idx from 'idx';

import { FileInput, StyledToggle } from '../../Formsy';
// import { objToArr } from '../../../helpers';
import MapDetailsFormSection from './MapDetailsFormSection';
import { Button } from '../../../components/UIKit';
import JumperModal from '../../JumperModal/JumperModal';
import Styles from './MapDetailsForm.styles';
import Input from '../../Formsy/Input';

class MapDetailsForm extends React.Component {
  constructor() {
    super();
    this.state = {
      canSubmit: false,
      isModalOpen: false,
    };

    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalSubmit = this.handleModalSubmit.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  onReset(fields) {
    const model = this.form.getModel();
    this.form.reset({ ...model, ...fields });
  }

  onValidSubmit(data) {
    const copy = { ...data };
    this.props.onValidSubmit(copy);

    // clear files so that they will not be submitted again
    if (copy.testImage || copy.prodImage) {
      this.switchAutoSubmit(false);
      const model = this.form.getModel();
      this.form.reset({ ...model, testImage: null, prodImage: null });
    }
  }

  openModal() {
    this.setState({
      isModalOpen: true,
    });
  }

  handleModalSubmit(event) {
    this.props.saveLayout();
    this.handleModalClose();
  }

  handleModalClose() {
    this.setState({
      isModalOpen: false,
    });
  }

  switchAutoSubmit(canSubmit) {
    this.setState({ canSubmit });
  }

  autoSubmit() {
    setTimeout(() => {
      if (this.state.canSubmit) {
        this.form.submit();
      }
    }, 500);
  }

  render() {
    const {
      testImage: { downloadURL: testDownloadUrl = '' } = {},
      prodImage: { downloadURL: prodDownloadUrl = '' } = {},
    } = this.props;
    return (
      <div>
        <Formsy
          onValid={() => {
            if (!this.props.switchDisabled) this.switchAutoSubmit(true);
          }}
          onInvalid={() => {
            this.switchAutoSubmit(false);
          }}
          onChange={() => {
            this.autoSubmit();
          }}
          onValidSubmit={this.onValidSubmit}
          style={{
            width: '100%',
            height: '100%',
          }}
          ref={(component) => {
            this.form = component;
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <MapDetailsFormSection
              onReset={this.onReset}
              title="Edited Map"
              contentStyle={{ paddingLeft: 10, paddingRight: 10 }}
              showIcon={false}
            >
              <div style={Styles.toggleLabels}>Test Map</div>
              <StyledToggle
                name="useProdImage"
                value={false}
                style={{
                  flex: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
                disabled={this.props.switchDisabled}
              />
              <div style={Styles.toggleLabels}>Production Map</div>
            </MapDetailsFormSection>
            <MapDetailsFormSection showIcon={false} onReset={this.onReset} title="Test Map">
              <FileInput
                key={'testMap'}
                name="testImage"
                style={{ color: 'black' }}
                imageUrl={testDownloadUrl}
                value={null}
              />
            </MapDetailsFormSection>
            <MapDetailsFormSection showIcon={false} onReset={this.onReset} title="Production Map">
              <FileInput
                key={'prodMap'}
                name="prodImage"
                style={{ color: 'black' }}
                imageUrl={prodDownloadUrl}
                value={null}
              />
            </MapDetailsFormSection>
            <MapDetailsFormSection
              showIcon={false}
              onReset={this.onReset}
              title="Meters / Pixels factor"
            >
              <Input
                name="units"
                type="number"
                placeholder="m/px"
                value={this.props.units || 0.25}
                style={{ wrapper: { margin: 0 }, color: 'black' }}
              />
            </MapDetailsFormSection>
            <MapDetailsFormSection
              showIcon={false}
              onReset={this.onReset}
              title="Panorama rotation offset"
            >
              <Input
                name="offset"
                placeholder="0"
                type="number"
                value={this.props.offset || ''}
                style={{ wrapper: { margin: 0 }, color: 'black' }}
              />
            </MapDetailsFormSection>
          </div>
        </Formsy>
        <Button
          type="none"
          style={{
            background: 'rgb(45,228,136)',
            marginLeft: '0px',
          }}
          onClick={this.openModal}
        >
          <span style={{ color: 'rgb(72,97,102)' }}>Generate portals</span>
        </Button>
        <JumperModal
          open={this.state.isModalOpen}
          handleClose={this.handleModalClose}
          handleSubmit={this.handleModalSubmit}
          title={'Generate portals layout?'}
        >
          Are you sure you want to generate portals layout? All portals on <i>_generated</i> layers{' '}
          <strong>will be replaced!</strong> This action is not reversible.
        </JumperModal>
      </div>
    );
  }
}

MapDetailsForm.propTypes = {
  onValidSubmit: PropTypes.func,
  units: PropTypes.number,
  offset: PropTypes.number,
  switchDisabled: PropTypes.bool,
};

MapDetailsForm.defaultProps = {
  onValidSubmit: () => {},
  units: 0.25,
  offset: 0,
  switchDisabled: false,
};

export default MapDetailsForm;



// WEBPACK FOOTER //
// ./src/components/Map/MapDetailsForm/MapDetailsForm.js